import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCardGift2 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M22 16V8a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3'
    />
    <path
      stroke='#05F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M23 10.5h-4m-18 0h4M9.035 12.244l5.93-3.488a2.02 2.02 0 0 1 2.388.247v0a2.024 2.024 0 0 1 0 2.995v0a2.02 2.02 0 0 1-2.388.246l-5.93-3.488a2.02 2.02 0 0 0-2.388.247v0a2.024 2.024 0 0 0 0 2.995v0a2.02 2.02 0 0 0 2.388.246'
    />
    <path
      stroke='#05F'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='m10 14.5 2-4 2 4'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCardGift2)
export default ForwardRef
